import { IonIcon } from '@ionic/react';
import { useIntl } from 'react-intl';

import styles from '@components/typography/Typography.module.css';
import { IconList, IconName } from '@utils/iconUtils';

type Props = {
  ariaLabelKey: string;
  color?: 'neutral300' | 'primary700' | 'shadesWhite' | 'neutral500' | 'neutral200' | 'success300';
  disabled?: boolean;
  icon: IconName;
  size?: 'medium' | 'large';
};

const ActionIcon = ({ ariaLabelKey, color = 'primary700', disabled, icon, size }: Props) => {
  const intl = useIntl();
  return (
    <IonIcon
      aria-label={intl.formatMessage({ id: ariaLabelKey })}
      className={`${styles.actionIcon} ${disabled ? styles.actionIconDisabled : ''} ${
        icon === 'spinner' ? styles.spin : ''
      } ${size === 'large' ? styles.actionIconLarge : size === 'medium' ? styles.actionIconMedium : ''} ${
        styles[color]
      }`}
      src={IconList[icon]}
    />
  );
};

export default ActionIcon;
